import { FORMAT_DISPLAY_OPTIONS } from '../../constants/formatConstants';
import { LocaleType } from '../../constants/localeConstants';
import { DateDisplayFormat } from '../../types';
import { getValidLocale } from '../internal/getValidLocale';

/**
 * Formats a native JavaScript Date using Intl.DateTimeFormat with a predefined format.
 *
 * @param date - The native Date object to be formatted.
 * @param format - The desired display format key (e.g. 'short', 'condensed').
 * @param locale - Optional BCP 47 locale string (e.g., "en-US").
 * @returns The formatted date string.
 */
export function formatNativeDate(date: Date, format: DateDisplayFormat, locale?: LocaleType, timeZone = 'UTC'): string {
  const validLocale = getValidLocale(locale);
  const formatter = new Intl.DateTimeFormat(validLocale, { ...FORMAT_DISPLAY_OPTIONS[format], timeZone });
  return formatter.format(date);
}
